import { Component, OnInit } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from "@angular/forms";
import { Route, Router, ActivatedRoute, NavigationEnd, NavigationStart } from '@angular/router';
import { trigger, state, style, animate, transition } from '@angular/animations';

import 'rxjs/add/operator/pairwise';
// APP
import { InformationService } from '../../../services/information.service';
import { SharedService } from '../../../services/shared.service';
import { MIHArea } from '../../../viewmodel';
import { Animations } from '../../common/animations';

@Component({
  selector: 'app-housing-area',
  templateUrl: './housing-area.component.html',
  providers: [InformationService],
  animations: [Animations.flyInOut]      
})
export class HousingAreaComponent implements OnInit {

    animate: string = 'active';
    title: string = 'Housing Area';
    projectId: number = 0;
    appName: string = '';
    appIdLabel: string = '';
    isEdit: boolean = false;  
    pageError: any = [];
    pageSuccess: any = [];
    submitted: boolean = false;
    mihAreaForm: FormGroup;
    model: MIHArea;
    isAppEditable: boolean = false;

    constructor(private router: Router
        , private frmBuilder: FormBuilder
        , private activeRoute: ActivatedRoute
        , private informationService: InformationService
        , private sharedService: SharedService) {   
        this.model = new MIHArea();
        this.model.ProjectId = this.projectId;        
    }

    ngOnInit() {

        let ids = this.sharedService.getJsonData("id"); 
        if (ids != null) {
            if (ids.projectId != null) {
                this.projectId = ids.projectId;
                this.appName = ids.appName;
                this.appIdLabel = ids.appIdLabel;
            }
        }    
        if (this.projectId <= 0)
            this.sharedService.navigateHome();

        this.mihAreaForm = this.frmBuilder.group({ 
            PrivateRezoning: [null, Validators.required],          
            ZoningResolutionMap: [null],
            BSASpecialPermit: [null, [Validators.required]],
            Description: []
        });

        this.informationService.getQuestionByType(this.projectId, 'MIHAREA')
            .subscribe(
            success => {
                if (!success.Success)
                    this.showError(success.StatusMessage);
                else {
                    this.model = success.Result;
                    this.isEdit = this.model.IsValid;
                                         
                    if (this.model.ProjectId == 0 && this.projectId == 0)
                        this.showError("Project ID not found!")
                    else if (this.model.ProjectId == 0)
                        this.model.ProjectId = this.projectId;
                }
            },
            error => {
                if (error.status == 401)
                    this.router.navigateByUrl('/login?session=0');

                this.showError(error.ExceptionMessage)
            }) 
    }

    changeDescriptionValidity() {       
        var data = this.mihAreaForm.get('BSASpecialPermit').value

        if (data === 'Y') {
            this.mihAreaForm.get('Description').setValidators([Validators.required ]);
        } else if (data === 'N') {
            this.mihAreaForm.get('Description').setValidators([]);
        }
        this.mihAreaForm.get('Description').updateValueAndValidity();

    }

    changeRezoningValidity() {
        var data = this.mihAreaForm.get('PrivateRezoning').value; 
        if (data == '0')
            this.mihAreaForm.get('ZoningResolutionMap').setValidators([Validators.required]);
        else 
            this.mihAreaForm.get('ZoningResolutionMap').setValidators([]);

        this.mihAreaForm.get('ZoningResolutionMap').updateValueAndValidity();
    }
   
    next(button) {

        this.submitted = true;        
        if (button === "PRE")
        {
            this.router.navigate(["/entity/addapplication"]);
            return true;
        }

        if (!this.mihAreaForm.valid) {
            return false;
        }

        if (this.model.ZoningResolutionMap != null)
            this.model.ZoningResolutionMap = this.model.ZoningResolutionMap.trim();

        if (this.model.BSASpecialPermit == 'Y' && this.model.Description != null)
            this.model.Description = this.model.Description.trim();
        
        if (this.model.PrivateRezoning == '0' && (this.model.ZoningResolutionMap ==null || this.model.ZoningResolutionMap == '')) {            
            this.changeRezoningValidity(); 

            if (this.model.BSASpecialPermit == 'Y' && (this.model.Description == null ||this.model.Description == '')) {
                this.changeDescriptionValidity();
                return false;
            } 
            return false;
        }

        if (this.model.BSASpecialPermit == 'Y' && (this.model.Description == null || this.model.Description == '')) {  
            this.changeDescriptionValidity(); 
            return false;
        }       

        if (this.model.BSASpecialPermit == 'N')
            this.model.Description = '';

        this.model.IsValid = this.mihAreaForm.valid;
        this.informationService.saveMIHArea(this.model)
            .subscribe(
            success => {
                if (!success.Success)
                    this.showError(success.StatusMessage);
                else {
                    if (button == 'NEXT')
                        this.router.navigate(["/information/construction"]);
                    else if (button = 'LATTER')
                        this.sharedService.navigateSummary();
                   
                }
            },
            error => {
                if (error.status == 401)
                    this.router.navigateByUrl('/login?session=0');

                this.showError(error.ExceptionMessage); 
            })
    }

    showError(msg) {
        this.pageError = []; this.pageSuccess = [];
        this.pageError.push(this.sharedService.getCustomError(msg));
        this.sharedService.processError(msg);
    }

    showSuccess(msg) {
        this.pageSuccess = []; this.pageError = [];
        this.pageSuccess.push(msg);
        this.sharedService.scroll();
    }

    closeError() {
        this.pageError = [];
        this.pageSuccess = [];
    }

    validateZoningMap()
    {
        var result = (this.mihAreaForm.controls['PrivateRezoning'].value == '0'  &&
            this.mihAreaForm.controls['ZoningResolutionMap'].hasError('required')) &&
            (this.mihAreaForm.controls['ZoningResolutionMap'].dirty || this.submitted);
        return result;
    }

    validateDescription()
    {
        var result = this.mihAreaForm.controls["BSASpecialPermit"].value === 'Y' &&            
            (this.mihAreaForm.controls["Description"].dirty || this.submitted);
        return result;
    }

    home() {
        this.sharedService.navigateHome(); 
    }

    summary() {
        this.sharedService.navigateSummary();
    }

}
